// HandoffCard — surfaces a quiet hand-off note from yesterday-you to
// today-you in Zone B. Italic Fraunces body, single dismiss CTA
// "Thanks, past me" that POSTs to /api/handoff/:id with action=consume.
//
// Distinct from the bedtime pledge (which is aspirational and shown
// inline on Today's Note). Hand-offs are operational ("if X happens,
// do Y") and only render in the morning after a write the previous
// evening. The body is preserved verbatim — no rendering of links,
// no markdown, no transforms — because the past-self voice is the
// only authoritative voice on this surface.
//
// Accessibility: explicit role="region" + aria-label so screen-reader
// users land on a labelled landmark when Zone B updates to this card.

import { Card } from '../ui/Card';
import { Button } from '../ui/Button';
import type { HandoffRow } from '@shared/types';

interface HandoffCardProps {
  handoff: HandoffRow;
  onConsume: () => void;
  consuming?: boolean;
}

export function HandoffCard({ handoff, onConsume, consuming }: HandoffCardProps) {
  return (
    <Card accentLeft role="region" aria-label="A note from yesterday">
      <span
        className="text-micro"
        style={{
          color: 'var(--color-ink-tertiary)',
          letterSpacing: '0.06em',
          textTransform: 'uppercase',
        }}
      >
        From last night
      </span>
      <p
        style={{
          marginBlockStart: 'var(--space-2)',
          marginBlockEnd: 0,
          maxInlineSize: '60ch',
          whiteSpace: 'pre-wrap',
          fontFamily: 'var(--font-heading)',
          fontStyle: 'italic',
          fontSize: 'var(--text-h3)',
          lineHeight: 'var(--leading-normal)',
          color: 'var(--color-ink-primary)',
        }}
      >
        {handoff.body}
      </p>
      <div
        className="row"
        style={{ marginBlockStart: 'var(--space-3)', justifyContent: 'flex-end' }}
      >
        <Button variant="tertiary" size="md" onClick={onConsume} loading={consuming}>
          Thanks, past me
        </Button>
      </div>
    </Card>
  );
}
